import React, { useState } from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SocialProofSection() {
  return <div className="w-full bg-white" data-id="element-271" data-mp="35pxdr18p352l">
      {/* SECTION 9 - TESTIMONIOS EXTENDIDOS */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-272" data-mp="30r3wqyu78vxo">
        <div className="text-center mb-14" data-id="element-273" data-mp="30rvrk7fz2pmw">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-slate-900 mb-4" data-id="element-274" data-mp="2d0zt4rh0gw6o">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-xl font-heading font-bold text-slate-900" data-id="element-275" data-mp="2849dg594c2ls">
            4.9/5
            <div className="flex text-amber-400" data-id="element-276" data-mp="2i0mand3vgyla">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-277" data-mp="29gg6w246giu" data-mpi={i} />)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-278" data-mp="3tgkkhj6vjonk">
          <TestimonialCard initials="MP" name="Martín P." city="Buenos Aires" quote="Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso." data-id="element-279" data-mp="yfscpzcgcdqt" />
          <TestimonialCard initials="CG" name="Carolina G." city="Bogotá" quote="Tres alumnos de nivel inicial que estaban estancados mejoraron su posición en cancha en el primer mes con el Tomo 2." data-id="element-280" data-mp="18dycobep79t1" />
          <TestimonialCard initials="FR" name="Federico R." city="Santiago" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo, veo el drill y en 5 minutos entro a la cancha." data-id="element-281" data-mp="kncedbuhx3w8" />
          <TestimonialCard initials="SV" name="Sofía V." city="Ciudad de México" quote="El Nivelómetro me cambió la vida. Antes ubicaba a los alumnos a ojo. Ahora los clasifico en 5 minutos y mis grupos son mucho más parejos." data-id="element-282" data-mp="thh2hni8w182" />
          <TestimonialCard initials="DA" name="Diego A." city="Lima" quote="Los diagramas de cancha son un lujo. Los imprimo y los uso en la clase para mostrarle al alumno dónde tiene que estar. Se entiende todo de inmediato." data-id="element-283" data-mp="1497pjwo2m48r" />
          <TestimonialCard initials="LR" name="Laura R." city="Montevideo" quote="El Kit de Supervivencia me salvó dos veces este mes. Una vez que llegó un alumno nuevo sin aviso y otra que el encargado no dejó el depósito abierto." data-id="element-284" data-mp="192tt8zc9axsf" />
        </div>
      </section>

      {/* SECTION 10 - GARANTÍA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-285" data-mp="qb13ddshhsox">
        <div className="max-w-2xl mx-auto bg-white rounded-3xl border-2 border-emerald-200 overflow-hidden shadow-lg" data-id="element-286" data-mp="25rrn8fc6mroj">
          <div className="p-8 text-center border-b border-slate-100" data-id="element-287" data-mp="21qpp61u04lo5">
            <div className="w-14 h-14 rounded-2xl bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto mb-5" data-id="element-288" data-mp="21sit39d8crsg">
              <ShieldCheck className="w-8 h-8" data-id="element-289" data-mp="2e9bleftdprfs" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900" data-id="element-290" data-mp="2e6fmop9piyqa">
              Garantía 7 días sin preguntas
            </h2>
          </div>
          <div className="p-8 sm:p-10 text-center text-slate-700 leading-relaxed" data-id="element-291" data-mp="24b4e6oow6nqz">
            <p className="mb-1.5" data-id="element-292" data-mp="2s1hyft18jib0">Abre los 12 Tomos.</p>
            <p className="mb-1.5" data-id="element-293" data-mp="2wz9yxbfy4cqt">Revisa los 6 Bonus.</p>
            <p className="mb-6" data-id="element-294" data-mp="2wyqla6xbwail">Úsalos en tu próxima clase.</p>

            <p className="font-bold text-slate-900 mb-2" data-id="element-295" data-mp="2ib5gm8kt238k">
              Si no es lo que esperabas →
            </p>
            <p className="text-emerald-600 font-heading font-extrabold text-2xl mb-6" data-id="element-296" data-mp="2n8f5nn4a8cvv">
              100% de devolución.
            </p>

            <p className="mb-8 text-slate-500" data-id="element-297" data-mp="3awybzx3ruflb">
              Sin preguntas. Sin formularios. Sin drama.
            </p>

            <div className="inline-block bg-slate-100 border border-slate-200 text-slate-600 font-bold px-5 py-2 rounded-full text-xs tracking-widest uppercase" data-id="element-298" data-mp="1s16d8o1f7894">
              Tasa de devoluciones menor al 2%
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 11 - FAQ */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-299" data-mp="1d4f9y3omlce8">
        <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-center text-slate-900 mb-12" data-id="element-300" data-mp="1d69uhgvzj2hs">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-301" data-mp="25tw0evsoqj7t">
          <AccordionItem question="¿Cómo recibo el material?" answer="Al completar el pago recibes un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos ya puedes estar abriendo tu primer tomo. No hay espera. No hay envío físico." data-id="element-302" data-mp="25tmhfs625cbm" />
          <AccordionItem question="¿Sirve si soy profe nuevo o si tengo años de experiencia?" answer="Sí para los dos casos. Si eres nuevo: el sistema te da la estructura que no te enseñaron en el curso de profe. Si tienes experiencia: te ahorra las horas que pierdes planificando desde cero y le da un marco profesional a lo que ya sabes hacer." data-id="element-303" data-mp="2tk02gyq86awp" />
          <AccordionItem question="¿Qué incluye exactamente el acceso?" answer="Un solo pago de USD 19 te da acceso completo a los 12 Tomos y a los 6 Bonus estratégicos. No hay planes, ni niveles, ni suscripciones: todo el material está incluido desde el primer momento." data-id="element-304" data-mp="3609jh7b8bkez" />
          <AccordionItem question="¿Qué diferencia hay con otros materiales que ya existen?" answer="La mayoría de los materiales para profes de pádel son genéricos o están en inglés. PADEL 360 fue diseñado en español neutro y pensado para el contexto latinoamericano: la forma de enseñar, el vocabulario, los niveles de los clubes y los tipos de alumnos que tiene un profe en la región." data-id="element-305" data-mp="3jzhj21bb0ujp" />
          <AccordionItem question="¿Sirve para grupos con niveles mezclados?" answer="Sí. El Bonus 1 (Nivelómetro) fue diseñado exactamente para ese problema. Te permite clasificar a cada alumno en 5 minutos y asignarle el tomo correcto. El Bonus 5 (Kit de Supervivencia) tiene además el protocolo específico para manejar grupos mixtos sin aviso." data-id="element-306" data-mp="7hb13a99e7bo" />
          <AccordionItem question="¿Qué pasa si no me sirve?" answer="Tienes 7 días de garantía total. Si abres el material y no es lo que esperabas, escríbenos y te devolvemos el 100% del dinero sin preguntas." data-id="element-307" data-mp="3iyfq7d21gx5d" />
          <AccordionItem question="¿El precio es un pago único?" answer="Sí. Son USD 19 una sola vez, sin suscripciones ni cobros recurrentes. El acceso al material queda tuyo para siempre, incluidas las actualizaciones futuras." data-id="element-308" data-mp="ajnondrugsbb" />
          <AccordionItem question="¿Puedo pagar con tarjeta de crédito?" answer="Sí. Aceptamos todas las tarjetas de crédito y débito, además de transferencia bancaria y los medios de pago locales disponibles en tu país." data-id="element-309" data-mp="2cdejxydjro8l" />
        </div>
      </section>
    </div>;
}
function TestimonialCard({
  initials,
  name,
  city,
  quote
}: {
  initials: string;
  name: string;
  city: string;
  quote: string;
}) {
  return <div className="bg-slate-50 rounded-2xl p-6 sm:p-7 border border-slate-200" data-id="element-310" data-mp="i2okdcwelho4">
      <div className="flex items-center gap-4 mb-5" data-id="element-311" data-mp="435mdcxb3mpj">
        <div className="w-11 h-11 rounded-full bg-court-deep text-white flex items-center justify-center font-bold" data-id="element-312" data-mp="42dpzzvvxky7">
          {initials}
        </div>
        <div data-id="element-313" data-mp="3qbf1mgdiaa1p">
          <p className="font-bold text-slate-900 text-sm" data-id="element-314" data-mp="3qbx25p77baff">{name}</p>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-315" data-mp="3v9q6ecoy1ud2">{city}</p>
        </div>
      </div>
      <div className="flex text-amber-400 mb-4" data-id="element-316" data-mp="1ojimkws4qi26">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-317" data-mp="1ohphvn12u7wt" data-mpi={i} />)}
      </div>
      <p className="text-slate-700 leading-relaxed text-sm sm:text-base" data-id="element-318" data-mp="1thtw16eiiqjv">
        "{quote}"
      </p>
    </div>;
}
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-2xl bg-white overflow-hidden" data-id="element-319" data-mp="7iezszemfhng">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 sm:p-6 text-left focus:outline-none" data-id="element-320" data-mp="2l5d3rim9k3b">
        <span className="font-bold text-slate-900 text-sm sm:text-base pr-4" data-id="element-321" data-mp="3toakrw7yswt4">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-court-deep transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-322" data-mp="3kpp2m26enjsv" />
      </button>
      <AnimatePresence data-id="element-323" data-mp="3fsyq1ott76c7">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-324" data-mp="1iyvkb7518oh6">
            <div className="px-5 sm:px-6 pb-6 text-slate-600 leading-relaxed text-sm sm:text-base border-t border-slate-100 pt-5" data-id="element-325" data-mp="1v9wcgoqgdolt">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}